<template>
    <div class="dj-container">
        <div class="head-container" @click="backList">
            <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#ff7f2e" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
        </div>
        <div class="dj-content" v-html="form.content">
        </div>
    </div>
</template>

<script>
import {infoZhengc} from "@/api/admin/zhengc"
import {timestampToTime} from "@/utils/date";

export default {
    name: "zhengcInfo",
    components: {
    },
    props:{
        zhengcId:{
            type: String,
            default:null
        },
    },
    watch:{
        zhengcId(newValue,oldValue){
            this.form = {}
            this.getZhengcInfo()
        },
    },
    data() {
        return {
            form:{},  //数据
            timestampToTime,
        };
    },
    created() {},
    mounted() {
        this.getZhengcInfo()
    },
    unmounted() {},
    computed: {},
    methods:{
        getZhengcInfo(){
            infoZhengc({ zhengcId: this.zhengcId }).then(res => {
                if (res.data.code === 1) {
                    this.form = res.data.data;
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        backList(){
            this.showMode = "page"
            this.$emit('change-mode',this.showMode);
        },
    },
};
</script>
<style scoped>
.dj-container{
    width: 100%;
    height: auto;
    background-color: #fff;
}
.dj-title{
    height: 40px;
    width: 98%;
    margin: auto;
    line-height: 40px;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid #DDD;
    margin-bottom: 10px;
}
.dj-time{
    height: 40px;
    width: 98%;
    margin: auto;
    line-height: 40px;
    font-size: 15px;
    color: #666666;
}
.dj-content{
    padding: 15px 0 15px 0;
    width: 96%;
    margin: auto;
    overflow-x: hidden;
    word-break: break-word;
}
.dj-content /deep/ img,
.dj-content /deep/ video {
    max-width: 100%;
    height: auto;
}
.dj-content /deep/ table {
    width: auto !important;
    max-width: 100%;
    table-layout: fixed;
}
.dj-content /deep/ td,
.dj-content /deep/ th {
    word-break: break-word;
}
.dj-content /deep/ pre {
    white-space: pre-wrap;
    word-break: break-all;
}
.head-container{
    margin-left: 5px;
    padding-top: 5px;
    cursor: pointer;
}
</style>